import { $Qll } from '../utils/query-selector'
import { $Q } from '../utils/querySelector'

export const selectTabs = (accordionsParam, contentParam) => {
  const accordions = $Qll(accordionsParam)
  const content = $Qll(contentParam)
  let activeAccordion = null

  const fatherTab = $Qll('.menu-component__submenu-list.js-submenu-list-component')

  fatherTab.forEach((validacion) => {
    validacion.addEventListener('click', (e) => {

      const currentTag = $Q('.first-level', e.currentTarget)

      accordions.forEach((elemento) => {
        elemento.classList.remove('isSelected')
      })

      currentTag.classList.add('isSelected')
      activeAccordion = currentTag.dataset.index

      content.forEach((contenedor) => {
        if (contenedor.dataset.index === activeAccordion) {
          // if (window.innerWidth < 999 && !contenedor.classList.contains('isSelected')) {
          //   const tabTitle = e.currentTarget
          //   const topOffset = tabTitle.offsetTop
          //   window.scrollTo({ top: topOffset, behavior: 'smooth' })
          // }
          contenedor.classList.add('isSelected')
        } else {
          contenedor.classList.remove('isSelected')
        }
      })
    })
  })


  // accordions.forEach((categoria) => {
  //   categoria.addEventListener('click', (e) => {
  //     accordions.forEach((elemento) => {
  //       elemento.classList.remove('isSelected')
  //     })

  //     e.currentTarget.classList.add('isSelected')
  //     activeAccordion = categoria.dataset.index

  //     content.forEach((contenedor) => {
  //       if (contenedor.dataset.index === activeAccordion) {
  //         if (window.innerWidth < 999 && !contenedor.classList.contains('isSelected')) {
  //           const tabTitle = e.currentTarget
  //           const topOffset = tabTitle.offsetTop
  //           window.scrollTo({ top: topOffset, behavior: 'smooth' })
  //         }
  //         contenedor.classList.add('isSelected')
  //       } else {
  //         contenedor.classList.remove('isSelected')
  //       }
  //     })
  //   })
  // })
}
